import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AnalyticsProvider } from './components/analytics/AnalyticsProvider';
import CookieConsent from './components/analytics/CookieConsent';
import ScrollToTop from './components/ScrollToTop';
import AppRoutes from './routes/AppRoutes';
import { usePageTracking } from './hooks/useAnalytics';

const AppContent = () => {
  usePageTracking();

  return (
    <>
      <AppRoutes />
      <CookieConsent />
    </>
  );
};

const App = () => {
  return (
    <AnalyticsProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <AppContent />
        </BrowserRouter>
      </AuthProvider>
    </AnalyticsProvider>
  );
};

export default App;
